import React, { useRef, useMemo } from 'react';
import { bool, func, string } from 'prop-types';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import { SignOut as SignOutIcon } from '@johnlewispartnership/wtr-ingredients/dist/foundations/icons';

import { chainHandlers } from 'utils/chain-handlers';
import { useMenuFocus } from 'components/MegaMenu/MenuFocusProvider';

import { urls } from 'constants/urls';

import styles from './SignOut.module.scss';

// TODO: Merge this component with ./Button/index.js if possible
const SignOut = ({ className, loggedIn, onBlur, onClick, onFocus }) => {
  const { state: authState } = useAuthentication();
  const visible = loggedIn && !authState.isSignedOnAsCustomer;
  const ref = useRef();
  const { handleClick, handleKeyDown, tabIndex } = useMenuFocus(ref, {
    skip: !visible,
  });

  const chainedHandleClick = useMemo(
    () => chainHandlers(handleClick, onClick),
    [handleClick, onClick],
  );

  return visible ? (
    <a
      className={className}
      data-test="signOut"
      href={urls.logout}
      onBlur={onBlur}
      onClick={chainedHandleClick}
      onFocus={onFocus}
      onKeyDown={handleKeyDown}
      ref={ref}
      tabIndex={tabIndex}
    >
      <SignOutIcon className={styles.icon} size="small" />
      Sign out
    </a>
  ) : null;
};

SignOut.propTypes = {
  className: string,
  loggedIn: bool.isRequired,
  onBlur: func,
  onClick: func,
  onFocus: func,
};

SignOut.defaultProps = {
  className: null,
  onBlur: null,
  onClick: null,
  onFocus: null,
};

SignOut.displayName = 'SignOutLink';

export { SignOut };
